<template>
	<div :class="{ 'chat-submit-container-1': messages.length > 0 }" class="chat-submit-container">
		<div style="width: 100%">
			<div v-show="!isConversations.title" class="welcome-header">
				<h3 class="welcome-title">基于特种设备知识库，为你答疑解惑</h3>
				<p class="welcome-subtitle">智能问答 · 法规检索 · 案例解读</p>
			</div>
		</div>
		<div class="chat-submit-main" :class="{ 'drag-over': isDragOver }" @dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop">
			<div class="book-tags-container" v-if="selectedBookList.length > 0">
				<el-tag v-for="book in selectedBookList" :key="book.value" closable type="info" @close="$emit('remove-book', book)" class="book-tag">
					<span class="book-tag-text">{{ book.catalog_type == 0 ? '企业知识库' : book.catalog_type == 1 ? '个人知识库' : '法规标准库' }} /</span>
					{{ book.name }}
				</el-tag>
			</div>
			<!-- 图片预览区（所有模式通用） -->
			<div v-if="localImages.length > 0" class="image-preview-container">
				<div class="image-preview-card" v-for="(img, index) in localImages" :key="index">
					<img :src="img.url" alt="图片" title="点击图片可放大" @click.stop="handleEnlargeImage(img.url)" />
					<span class="image-preview-close" @click="handleRemoveImage(index)">✕</span>
				</div>
			</div>
			<div class="autocomplete-textarea-wrapper">
				<el-input
					ref="searchInput"
					:value="value"
					@input="handleInput"
					:readonly="isLastMessageTyping"
					:maxlength="3000"
					:autosize="{ minRows: 1, maxRows: 6 }"
					class="input-with-select"
					placeholder="请输入内容... (输入标准编号或者标准名称可快捷检索，Enter发送，Shift+Enter换行)"
					type="textarea"
					@keydown.enter.native="handleEnterKey"
					@keydown.native="handleTextareaKeydown"
					@paste.native="handlePaste"
				>
				</el-input>
				<transition name="dropdown-fade">
					<div class="autocomplete-dropdown" :class="{ 'autocomplete-dropdown-up': dropUp }" v-show="suggestionsVisible && suggestions.length > 0">
						<div
							v-for="(item, index) in suggestions"
							:key="index"
							class="autocomplete-item"
							:class="{ 'autocomplete-item-active': index === suggestionIndex }"
							@mousedown.prevent="handleSuggestionSelect(item)"
							@mouseenter="suggestionIndex = index"
						>
							<span class="autocomplete-item-code" v-if="item.standardCode">{{ item.standardCode }}</span>
							<span class="autocomplete-item-name">{{ item.standardName }}</span>
						</div>
					</div>
				</transition>
			</div>
		</div>
		<!-- 提交按钮区域 -->
		<div class="chat-submit-bar">
			<div class="chat-type-container">
				<!-- 模式下拉选择 -->
				<el-popover placement="bottom-start" width="280" trigger="click" popper-class="popover-mode-dropdown" v-model="modeDropdownVisible">
					<div class="mode-select-list">
						<div :class="['mode-select-item', { 'mode-select-item-active': chatType == 'auto'}]" @click="handleModeSelect('auto')">
							<!-- <div class="mode-select-icon"><i class="el-icon-refresh"></i></div> -->
							 <div class="mode-select-icon"><i class="icon-sync iconfont"></i></div>
							<div class="mode-select-info">
								<div class="mode-select-name">自动模式</div>
								<div class="mode-select-desc">智能匹配最佳回答方式</div>
								<div class="mode-select-count" v-if="!uisLogin">当天剩余体验次数：{{ aiCount.autoPost }} 次</div>
							</div>
							<i v-if="chatType == 'auto'" class="el-icon-check mode-select-check"></i>
						</div>
						<div :class="['mode-select-item', { 'mode-select-item-active': chatType == 'rag'|| chatType == 'book','mode-select-item-disabled': showAutoBadge  }]" @click="handleModeSelect('rag')">
							<!-- <div class="mode-select-icon"><i class="el-icon-aim"></i></div> -->
							 <div class="mode-select-icon"><i class="icon-thunderbolt  iconfont"></i></div>
							<div class="mode-select-info">
								<div class="mode-select-name">快速回答</div>
								<div class="mode-select-desc">基于法规标准库快速检索回答</div>
								<!-- <div class="mode-select-count" v-if="!uisLogin">剩余体验次数：{{ aiCount.rag }} 次</div> -->
							</div>
							<i v-if="chatType == 'rag'" class="el-icon-check mode-select-check"></i>
						</div>
						<div :class="['mode-select-item', { 'mode-select-item-active': chatType == 'agent', 'mode-select-item-disabled': showAgentBadge }]" @click="handleModeSelect('agent')">
							<!-- <div class="mode-select-icon"><i class="el-icon-bangzhu"></i></div> -->
							  <div class="mode-select-icon"><i class="icon-shendusikao1 iconfont"></i></div>
							<div class="mode-select-info">
								<div class="mode-select-name">深度思考</div>
								<div class="mode-select-desc">多步推理，研究级专业问答</div>
								<!-- <div class="mode-select-count" v-if="!uisLogin">剩余{{ aiCount.agent }}次</div> -->
							</div>
							<i v-if="chatType == 'agent'" class="el-icon-check mode-select-check"></i>
						</div>
						<div v-if="!uisLogin" class="mode-select-login-tip">
							<el-link :underline="false" type="primary" @click="$emit('login')">登录</el-link>
							<span>可体验更多功能</span>
						</div>
					</div>
					<span slot="reference" :class="{ 'mode-select-trigger chat-type-active': true, 'chat-type-disabled': false }">
						<i :class="currentModeIcon" class="mode-trigger-icon iconfont"></i>
						<span class="mode-trigger-label">{{ currentModeLabel }}</span>
						<i class="el-icon-arrow-down mode-trigger-arrow"></i>
					</span>
				</el-popover>
				<!-- 书单模式（独立按钮） -->
				<el-popover placement="bottom" width="220" trigger="hover" popper-class="popover-mode">
					<div class="popover-mode-content popover-mode-content-book">
						<p class="popover-mode-title">书单模式</p>
						<p class="tip">在所选书单文件中精准检索回答</p>
						<p class="tip">选择书单后，AI仅在所选书单的文件中检索回答</p>
						<p class="tip">每次对话最多可选3个书单，书单中未被AI知识库收录的文件无法使用</p>
						<p class="flexStart" v-if="!uisLogin"><el-link :underline="false" type="primary" style="margin-left: 0; font-size: 13px" @click="$emit('login')">登录</el-link>可体验此功能</p>
					</div>
					<span slot="reference" :class="{ 'chat-type-active': chatType == 'book', 'chat-type-disabled': !uisLogin }" class="chat-type" @click="$emit('change-chat-type', 'book')"
						><i class="el-icon-collection" style="margin-right: 2px"></i>书单模式
						<i class="el-icon-arrow-down"></i>
					</span>
				</el-popover>
			</div>
			<div style="display: flex;">
				<!-- 上传图片 -->
				<ImageUploader ref="imageUploader" :value="pendingImages" :can-upload="canUploadImage" @change="handleUpdateImages" />
				<span>
					<el-button :icon="isLastMessageTyping ? 'el-icon-video-pause' : 'el-icon-position'" round style="margin-left: 10px; margin-right: 10px" type="primary" @click="handleButtonClick">{{
						isLastMessageTyping ? '暂停' : '提交'
					}}</el-button>
				</span>
				<el-button :disabled="messages.length == 0" circle icon="el-icon-delete" title="清空当前对话" type="primary" @click="$emit('clear')"></el-button>
			</div>
		</div>
		<p style="color: #81858c; font-size: 12px;margin: 8px 0px 4px;">
			本内容由AI生成，请审慎参考。如发现错误，欢迎点击"不喜欢"反馈，助力我们优化模型。感谢您的支持！ <span v-if="!uisLogin">（登录后可体验更多功能，如：深度思考、可信溯源、选择书单等，欢迎登录！）</span>
		</p>
	</div>
</template>

<script>
import { getSearchList } from '@/api/standards/search';
import ImageUploader from './ImageUploader.vue';

	export default {
		name: 'ChatInput',
		components: {
			ImageUploader
		},
		model: {
			prop: 'value',
			event: 'input'
		},
		data() {
			return {
				// 本地图片列表（上传后立即回显，不依赖 prop 回流延迟）
				localImages: [],
				isDragOver: false,
				modeDropdownVisible: false,
				suggestions: [],
				suggestionsVisible: false,
				suggestionIndex: -1,
				searchTimer: null,
				dropUp: false
			};
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			isConversations: {
				type: Object,
				default: () => ({})
			},
			messages: {
				type: Array,
				default: () => []
			},
			selectedBookList: {
				type: Array,
				default: () => []
			},
			chatType: {
				type: String,
				default: 'rag'
			},
			uisLogin: {
				type: Boolean,
				default: false
			},
			uisVip: {
				type: Boolean,
				default: false
			},
			aiCount: {
				type: Object,
				default: () => ({ auto: 0, rag: 0, agent: 0, agentPost: 0, autoPost: 0, ragPost: 0 })
			},
			showAutoBadge: {
				type: Boolean,
				default: false
			},
			showRagBadge: {
				type: Boolean,
				default: false
			},
			showAgentBadge: {
				type: Boolean,
				default: false
			},
			isLastMessageTyping: {
				type: Boolean,
				default: false
			},
			shouldDisableSubmit: {
				type: Boolean,
				default: false
			},
			// 待发送图片列表（由 ImageUploader 组件维护内容）
			pendingImages: {
				type: Array,
				default: () => []
			}
		},
		computed: {
			// 是否允许上传图片：已登录，或3种模式中任一有剩余次数
			canUploadImage() {
				if (this.uisLogin) return true;
				const count = this.aiCount || {};
				return (count.autoPost > 0) || (count.ragPost > 0) || (count.agentPost > 0);
			},
			currentModeLabel() {
				const labels = { auto: '自动模式', rag: '快速回答', agent: '深度思考', book: '快速回答' };
				return labels[this.chatType] || '快速回答';
			},
			currentModeIcon() {
				const icons = { auto: 'icon-sync', rag: 'icon-thunderbolt', agent: 'icon-shendusikao', book: 'icon-thunderbolt' };
				return icons[this.chatType] || 'icon-sync';
			},
			currentRemainCount() {
				if (this.chatType === 'rag') {
					return this.aiCount.ragPost;
				}
				if (this.chatType === 'agent') {
					return this.aiCount.agentPost;
				}
				return null;
			}
		},
		watch: {
			// 输入被外部清空时关闭下拉
			value(newVal) {
				if (!newVal || !newVal.trim()) {
					this.suggestionsVisible = false;
					this.suggestions = [];
				}
			},
			// 切换模式时不再清空图片，保留已上传的图片
			chatType(newVal) {
				this.suggestionsVisible = false;
				this.suggestions = [];
			},
			// 选择/移除书单时关闭下拉
			selectedBookList() {
				this.suggestionsVisible = false;
				this.suggestions = [];
			},
			// 外部清空图片时同步本地
			pendingImages(val) {
				if (!val || val.length === 0) {
					this.localImages = [];
				}
			}
		},
		methods: {
			handleModeSelect(mode) {
				this.modeDropdownVisible = false;
				// 切换到自动或深度思考模式时，清空已选书单
				if ((mode === 'auto' || mode === 'agent') && this.selectedBookList.length > 0) {
					this.$emit('clear-books');
				}
				this.$emit('change-chat-type', mode);
			},
			handleUpdateImages(val) {
				// val 是 ImageUploader 新上传的图片数组
				this.localImages = this.localImages.concat(val);
				this.$emit('update:pending-images', this.localImages);
				// 如果之前是书单模式，先清空书单（但不自动切换模式）
				if (this.chatType === 'book') {
					this.$emit('clear-books');
				}
			},
			handleRemoveImage(index) {
				this.localImages.splice(index, 1);
				// 同步 ImageUploader 的计数
				if (this.$refs.imageUploader) {
					this.$refs.imageUploader.removeOne();
				}
				this.$emit('update:pending-images', this.localImages);
			},
			// 点击图片放大预览
			handleEnlargeImage(src) {
				if (window.EReg && window.EReg.enlargeImage) {
					window.EReg.enlargeImage(src);
				}
			},
			handleEnterKey(event) {
				// 如果下拉框可见且有选中项，选择该项
				if (this.suggestionsVisible && this.suggestionIndex >= 0 && this.suggestions.length > 0) {
					event.preventDefault();
					this.handleSuggestionSelect(this.suggestions[this.suggestionIndex]);
					return;
				}
				// 关闭下拉框
				if (this.suggestionsVisible) {
					this.suggestionsVisible = false;
				}
				if (!event.shiftKey) {
					event.preventDefault();
					this.$emit('submit');
				}
			},
			handleButtonClick() {
				if (this.isLastMessageTyping) {
					this.$emit('pause');
				} else {
					this.$emit('submit');
				}
			},
			// 输入处理（触发联想检索）
			handleInput(value) {
				this.$emit('input', value);
				// 防抖检索
				if (this.searchTimer) {
					clearTimeout(this.searchTimer);
				}
				// 内容为空时立即关闭下拉框
				if (!value || !value.trim()) {
					this.suggestionsVisible = false;
					this.suggestions = [];
					return;
				}
				this.searchTimer = setTimeout(() => {
					this.querySearch(value.trim());
				}, 300);
			},
			// 调用标准检索接口
			async querySearch(queryString) {
				if (!queryString) {
					this.suggestionsVisible = false;
					this.suggestions = [];
					return;
				}
				try {
					const res = await getSearchList({ searchValue: queryString });
					if (res.code == 200 && res.data && res.data.length > 0) {
						this.suggestions = res.data.filter(item => item.standardName).slice(0, 8);
						this.suggestionIndex = -1;
						this.calcDropDirection();
						this.suggestionsVisible = true;
					} else {
						this.suggestionsVisible = false;
						this.suggestions = [];
					}
				} catch (e) {
					console.error('联想检索失败', e);
					this.suggestionsVisible = false;
				}
			},
			// 选中联想条目
			handleSuggestionSelect(item) {
				this.$emit('input', item.standardCode || item.standardName);
				this.suggestionsVisible = false;
				this.suggestions = [];
				this.suggestionIndex = -1;
			},
			// 计算下拉方向：下方空间不足则向上弹出
			calcDropDirection() {
				this.$nextTick(() => {
					const wrapper = this.$el.querySelector('.autocomplete-textarea-wrapper');
					if (!wrapper) return;
					const rect = wrapper.getBoundingClientRect();
					const spaceBelow = window.innerHeight - rect.bottom;
					this.dropUp = spaceBelow < 260;
				});
			},
			// 键盘导航
			handleTextareaKeydown(event) {
				if (!this.suggestionsVisible || this.suggestions.length === 0) {
					return;
				}
				if (event.key === 'ArrowDown') {
					event.preventDefault();
					this.suggestionIndex = (this.suggestionIndex + 1) % this.suggestions.length;
					this.$nextTick(() => {
						this.scrollToSuggestion();
					});
				} else if (event.key === 'ArrowUp') {
					event.preventDefault();
					this.suggestionIndex = (this.suggestionIndex - 1 + this.suggestions.length) % this.suggestions.length;
					this.$nextTick(() => {
						this.scrollToSuggestion();
					});
				} else if (event.key === 'Escape') {
					event.preventDefault();
					this.suggestionsVisible = false;
					this.suggestions = [];
					this.suggestionIndex = -1;
				}
			},
			scrollToSuggestion() {
				this.$nextTick(() => {
					const suggestion = this.$el.querySelector('.autocomplete-item-active');
					if (suggestion) {
						suggestion.scrollIntoView({ block: 'nearest' });
					}
				});
			},
			// 拖拽图片
			handleDragOver(event) {
				// if (!this.canUploadImage) return;
				const types = event.dataTransfer.types;
				if (types && types.includes('Files')) {
					this.isDragOver = true;
				}
			},
			handleDragLeave(event) {
				// 防止子元素触发 dragleave
				if (event.currentTarget.contains(event.relatedTarget)) return;
				this.isDragOver = false;
			},
			handleDrop(event) {
				this.isDragOver = false;
				// if (!this.canUploadImage) {
				// 	this.$message.warning('当前没有可用次数，请先登录');
				// 	return;
				// }
				const files = event.dataTransfer.files;
				if (!files || files.length === 0) return;
				const imageFiles = [];
				for (let i = 0; i < files.length; i++) {
					if (files[i].type.startsWith('image/')) {
						imageFiles.push(files[i]);
					}
				}
				if (imageFiles.length > 0) {
					if (this.$refs.imageUploader) {
						this.$refs.imageUploader.processFiles(imageFiles);
					}
				}
			},
			// 粘贴图片（Ctrl+V）—— 只要3种模式中有使用次数就允许
			handlePaste(event) {
				// if (!this.canUploadImage) {
				// 	this.$message.warning('当前没有可用次数，请先登录');
				// 	return;
				// }
				const items = event.clipboardData && event.clipboardData.items;
				if (!items) return;
				const imageFiles = [];
				for (let i = 0; i < items.length; i++) {
					if (items[i].type.startsWith('image/')) {
						const file = items[i].getAsFile();
						if (file) {
							imageFiles.push(file);
						}
					}
				}
				if (imageFiles.length > 0) {
					event.preventDefault();
					if (this.$refs.imageUploader) {
						this.$refs.imageUploader.processFiles(imageFiles);
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.book-tags-container {
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 10px 10px 0;

		.book-tag {
			margin: 0;
			font-size: 14px;
			color: #606266;
		}
	}

	// 图片预览区（DeepSeek 风格）
	.image-preview-container {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 8px 10px 0;
	}

	.image-preview-card {
		position: relative;
		width: 64px;
		height: 64px;
		border-radius: 10px;
		border: 1px solid #e5e7eb;
		overflow: hidden;
		background: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
			cursor: pointer;
			transition: transform 0.2s ease-in-out;
		}

		.image-preview-close {
			position: absolute;
			top: 4px;
			right: 4px;
			width: 18px;
			height: 18px;
			line-height: 18px;
			text-align: center;
			font-size: 11px;
			font-weight: 700;
			color: #fff;
			background: rgba(0, 0, 0, 0.55);
			border-radius: 50%;
			cursor: pointer;
			opacity: 0;
			transition: opacity 0.15s, background 0.15s;

			&:hover {
				background: rgba(0, 0, 0, 0.8);
			}
		}

		&:hover .image-preview-close {
			opacity: 1;
		}

		&:hover img {
			transform: scale(1.1);
			transition: transform 0.2s ease-in-out;
		}
	}

	.input-with-select {
		padding: 8px 0;
		min-height: 40px;
		box-sizing: border-box;
	}

	::v-deep textarea {
		margin-bottom: 48px;
		border: 0px;
		resize: none;
		max-height: 200px;
		overflow-y: auto !important;
	}

	.autocomplete-textarea-wrapper {
		position: relative;
		width: 100%;
	}

	// 自动补全下拉
	.autocomplete-dropdown {
		position: absolute;
		left: 0;
		right: 0;
		top: 100%;
		z-index: 100;
		background: #fff;
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
		max-height: 240px;
		overflow-y: auto;
		margin-top: 2px;
	}

	.autocomplete-item {
		display: flex;
		align-items: center;
		padding: 8px 14px;
		cursor: pointer;
		transition: background 0.15s;
		gap: 8px;

		&:hover {
			background: #f1f5f9;
		}
	}

	.autocomplete-item-active {
		background: #edf3fe;
	}

	.autocomplete-item-code {
		font-size: 12px;
		color: #2563eb;
		font-weight: 600;
		white-space: nowrap;
		flex-shrink: 0;
		background: #eff6ff;
		padding: 2px 6px;
		border-radius: 4px;
	}

	.autocomplete-item-name {
		font-size: 13px;
		color: #1e293b;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	// 下拉渐变动画
	.dropdown-fade-enter-active {
		transition: opacity 0.2s ease, transform 0.2s ease;
	}
	.dropdown-fade-leave-active {
		transition: opacity 0.15s ease, transform 0.15s ease;
	}
	.dropdown-fade-enter,
	.dropdown-fade-leave-to {
		opacity: 0;
		transform: translateY(-6px);
	}

	// 向上弹出样式
	.autocomplete-dropdown-up {
		top: auto !important;
		bottom: 100%;
		margin-top: 0;
		margin-bottom: 2px;
	}

	.chat-submit-container {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		flex-shrink: 0;
	}

	.chat-submit-container-1 {
		justify-content: flex-end !important;
		padding-top: 24px;
	}

	.chat-submit-main {
		width: 100%;
		max-width: 70rem;
		margin: 0 auto;
		overflow: visible;
		border: 1px solid #e2e8f0;
		border-radius: 16px;
		background: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.03);
		transition: border-color 0.2s, box-shadow 0.2s;
	}

	.chat-submit-main.drag-over {
		border-color: #2563eb;
		box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
		position: relative;

		&::after {
			content: '拖放图片到此处上传';
			position: absolute;
			inset: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(255, 255, 255, 0.85);
			color: #2563eb;
			font-size: 16px;
			font-weight: 600;
			border-radius: 16px;
			z-index: 10;
			pointer-events: none;
		}
	}

	// 覆盖提交按钮样式
	/deep/ .chat-submit-bar .el-button--primary {
		background-color: #155dfc;
		border-color: #155dfc;
	}

	/deep/ .chat-submit-bar .el-button--primary:hover {
		background-color: #1447e6;
		border-color: #1447e6;
	}

	// 覆盖输入框样式
	/deep/ .chat-submit-main .el-textarea__inner {
		border: none;
		box-shadow: none;
		font-size: 14px;
		color: #1e293b;
		min-height: 32px;
		line-height: 1.6;
		max-height: 200px;
		overflow-y: auto !important;
	}

	/deep/ .chat-submit-main .el-textarea__inner:focus {
		border: none;
		box-shadow: none;
	}

	/deep/ .chat-submit-main .el-input__count {
		bottom: 48px !important;
		right: 22px !important;
		color: #94a3b8;
		background: transparent;
	}

	.chat-submit-bar {
		z-index: 1;
		display: flex;
		margin-top: -48px;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		max-width: 70rem;
		height: 48px;
	}

	.chat-type {
		padding: 7px 20px;
		background-color: #fff;
		border-radius: 18px;
		cursor: pointer;
		font-size: 13px;
		margin-left: 10px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		color: #0f1115;
	}

	.chat-type-active {
		// color: #155dfc;
		// background: #dbeafe;

		color: #3964fe !important;
		background: #edf3fe !important;
		border: 1px solid #b7c8fe !important;
	}

	.chat-type-disabled {
		color: #bcbec2;
		background-color: #f4f4f5;
		border-color: #e9e9eb;
		cursor: not-allowed;
	}

	.welcome-header {
		text-align: center;
		margin-bottom: 32px;
	}

	.welcome-title {
		font-size: 24px;
		font-weight: 700;
		color: #0f172a;
		margin: 0 0 8px;
	}

	.welcome-subtitle {
		font-size: 14px;
		color: #64748b;
		margin: 0;
	}

	// 模式下拉触发器
	.mode-select-trigger {
		display: inline-flex;
		align-items: center;
		padding: 3px 16px;
		background-color: #fff;
		border-radius: 18px;
		cursor: pointer;
		font-size: 13px;
		margin-left: 10px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		color: #0f1115;
		transition: all 0.2s;

		&:hover {
			border-color: #b7c8fe;
			background: #edf3fe;
		}
	}

	.mode-trigger-icon {
		margin-right: 6px;
		font-size: 16px;
	}

	.mode-trigger-label {
		font-weight: 500;
	}

	.mode-trigger-arrow {
		margin-left: 6px;
		font-size: 12px;
		color: #94a3b8;
	}

	.mode-remain-count {
		font-size: 12px;
		color: #94a3b8;
		margin-left: 12px;
		white-space: nowrap;
	}
</style>

<style lang="less">
	.popover-mode-dropdown {
		padding: 4px 0 !important;
	}

	.mode-select-item {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		cursor: pointer;
		transition: background 0.15s;

		&:hover {
			background: #f1f5f9;
		}
	}

	.mode-select-item-active {
		background: #edf3fe;

		&:hover {
			background: #dbeafe;
		}
	}

	.mode-select-item-disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover {
			background: transparent;
		}
	}

	.mode-select-icon {
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #f1f5f9;
		border-radius: 8px;
		margin-right: 12px;
		font-size: 16px;
		color: #475569;
		flex-shrink: 0;
	}

	.mode-select-item-active .mode-select-icon {
		background: #dbeafe;
		color: #155dfc;
	}

	.mode-select-info {
		flex: 1;
		min-width: 0;
	}

	.mode-select-name {
		font-size: 14px;
		font-weight: 500;
		color: #0f172a;
		line-height: 1.4;
	}

	.mode-select-desc {
		font-size: 12px;
		color: #94a3b8;
		line-height: 1.4;
		margin-top: 2px;
	}

	.mode-select-count {
		font-size: 12px;
		color: #475569;
		font-weight: 500;
		line-height: 1.4;
		margin-top: 2px;
	}

	.mode-select-login-tip {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 16px;
		border-top: 1px solid #e2e8f0;
		margin-top: 4px;
		font-size: 13px;
		color: #0f172a;
		background: #f8fafc;

		.el-link {
			font-size: 13px;
			margin-right: 4px;
		}
	}

	.mode-select-check {
		color: #155dfc;
		font-size: 20px;
		font-weight: 700 !important;
		flex-shrink: 0;
		margin-left: 8px;
	}
</style>
